import { useReveal } from "@/hooks/useReveal";
import { UFJ_IMAGES } from "./data";

export default function UFJIntroduction() {
  const eyebrow = useReveal();
  const title = useReveal();
  const body = useReveal();
  const imageR = useReveal();

  return (
    <section
      data-testid="ufj-introduction"
      className="relative bg-black py-28 md:py-40 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 order-2 lg:order-1">
          <p ref={eyebrow} className="pd-reveal eyebrow" data-testid="ufj-intro-eyebrow">
            A collection by curation, not inventory
          </p>
          <h2
            ref={title}
            className="pd-reveal mt-6 font-serif-display text-4xl md:text-5xl lg:text-6xl text-white tracking-[0.06em] leading-[1.08]"
            style={{ transitionDelay: "160ms" }}
            data-testid="ufj-intro-title"
          >
            Pieces chosen <br />
            <span className="italic font-serif-body text-white/85">one at a time.</span>
          </h2>
          <div ref={body} className="pd-reveal mt-10 space-y-6" style={{ transitionDelay: "320ms" }}>
            <p className="font-light text-white/70 text-base md:text-lg leading-relaxed tracking-wide">
              Ultra Fine Jewelry is the private chapter of the PiérrecDavís maison — a small body of exceptional creations composed for a discerning circle of clients. Each piece passes through the atelier before it ever reaches a vitrine.
            </p>
            <p className="font-light text-white/55 text-base leading-relaxed tracking-wide">
              Our clients are introduced to new work privately. Pieces are released without announcement, acquired by invitation, and in many cases retired after a single commission.
            </p>
            <p className="font-serif-body italic text-white/75 text-lg md:text-xl pt-2">
              "Rise above the ordinary."
            </p>
          </div>
        </div>

        <div ref={imageR} className="pd-reveal lg:col-span-6 order-1 lg:order-2" style={{ transitionDelay: "260ms" }}>
          <div className="relative aspect-[4/5] overflow-hidden border border-[var(--pd-border)]">
            <img
              src={UFJ_IMAGES.intro}
              alt="Haute joaillerie — concept imagery"
              className="w-full h-full object-cover transition-transform duration-[2400ms] hover:scale-105"
              data-testid="ufj-intro-image"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent pointer-events-none" />
            <div className="absolute top-4 left-4">
              <span className="text-[0.55rem] uppercase tracking-[0.42em] text-white/55 bg-black/60 backdrop-blur px-3 py-1.5">
                Concept Imagery
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
